import { DynamicFieldItem } from "../../../../../model/dynamic-forms";
import { FieldType } from "../../../../../model/service-request/attribute";

export function formatDynamicFieldValue(item: DynamicFieldItem): string {
	const { fieldType, fieldValue } = item;

	if (fieldType === FieldType.File || fieldType === FieldType.Image) {
		if (item.fileFileName) return item.fileFileName;
		if (fieldValue instanceof File) return fieldValue.name;
		return fieldValue != null ? String(fieldValue) : "";
	}

	if (fieldType === FieldType.DateTime) {
		const date = new Date(fieldValue);
		if (isNaN(date.getTime())) return fieldValue != null ? String(fieldValue) : "";
		return date.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
	}

	if (
		fieldType === FieldType.Dropdown ||
		fieldType === FieldType.ConditionalDropdown ||
		fieldType === FieldType.SingleSelect ||
		fieldType === FieldType.MultiSelect
	) {
		return item.dropdownText ?? "";
	}

	if (fieldType === FieldType.Bool) {
		return fieldValue ? "Yes" : "No";
	}

	return fieldValue != null ? String(fieldValue) : "";
}
